const localState = {
  modalOpen: false,
  fullScreen: true,
};

export const mutations = {
  SET_MODAL_ACTIVE(state, active) {
    state.modalOpen = active;

    if (state.modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  },

  SET_FULL_SCREEN(state, fullScreen) {
    state.fullScreen = fullScreen;
  },
};

export const state = localState;

export default {
  state,
  mutations,
};
